import { buildPermissionSelections } from '../../config/permissionsConfig';

const state = () => ({
  permissions: buildPermissionSelections(false),
});

export default state;
